import React, { useEffect, useState } from 'react';

import { Box, Text } from '@betterment/samba-react';

import { FooterText } from '../../../components/Footer';
import disclosureInitializer from '../disclosureInitializer';

export const Disclosures: React.FC = () => {
  const [disclosures, setDisclosures] = useState<string[]>([]);

  useEffect(() => {
    disclosureInitializer.subscribe(value => {
      const filteredDisclosures = Object.values(value).filter(disclosure => disclosure !== undefined);
      setDisclosures(filteredDisclosures);
    });

    return () => disclosureInitializer.unsubscribe();
  }, []);

  if (disclosures.length < 1) return null;

  return (
    <Box css={{ mb: 'space.300' }}>
      {disclosures.map(value => (
        <Text as="p" key={value} className={FooterText} dangerouslySetInnerHTML={{ __html: value }} />
      ))}
    </Box>
  );
};
